// extracted by mini-css-extract-plugin
module.exports = {"scrollImage":"ScrollImgs_style_scrollImage__3A9b1","imgBox":"ScrollImgs_style_imgBox__1fjoo","empty":"ScrollImgs_style_empty__2dc4S","imgItem":"ScrollImgs_style_imgItem__3zhVg"};